import { components } from 'react-select';

const CustomDropdownContainer = (props) => {
  const selected = props.getValue();
  const maxToShow = 2;
  const displayValues = selected.slice(0, maxToShow);
  const extraCount = selected.length - maxToShow;

  const input = Array.isArray(props.children) ? props.children[1] : props.children;

  return (
    <components.ValueContainer {...props}>
      {/* Let react-select show placeholder automatically */}
      {selected.length === 0 ? props.children : (
        <>
          {displayValues.map((val) => (
            <div
              key={val.id || val.value}
              className="custom-multi-tag"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '2px 6px',
                marginRight: 4,
                backgroundColor: '#e2e6ea',
                borderRadius: 4,
              }}
            >
              <span style={{ marginRight: 4 }}>
                {val.client_name || val.designation_name || val.label}
              </span>
              <span
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  const newValue = selected.filter(s => s.value !== val.value);
                  props.setValue(newValue, 'remove-value');
                }}
              >
                ×
              </span>
            </div>
          ))}

          {extraCount > 0 && (
            <div style={{ marginLeft: 4, fontSize: 12, color: '#555' }}>
              +{extraCount} more
            </div>
          )}
          {input}
        </>
      )}
    </components.ValueContainer>
  );
};

export default CustomDropdownContainer;
